module.exports = __webpack_public_path__ + "img/icon_store.2fe70193.png";